import type { ReactNode, SVGProps } from 'react'

import { CustomIconProps } from '../types/types'

interface IconTemplateProps extends CustomIconProps {
	children: ReactNode
}

export const IconTemplateIPortIcon = (props: SVGProps<SVGSVGElement> & IconTemplateProps) => {
	const { children, title, size, ...otherProps } = props

	const customSize = size || '1em'

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={customSize}
			height={customSize}
			fill="none"
			viewBox="0 0 24 24"
			{...otherProps}
		>
			<>
				{title ? <title>{title}</title> : null}
				{children}
			</>
		</svg>
	)
}
